var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-radio",on:{"click":function($event){return _vm.onClick()}}},[_c('input',{class:[`form-radio__field`, _vm.checked && `form-radio__field--checked`],attrs:{"id":`singleRadio-${_vm.label}`,"type":"radio","name":`singleRadio-${_vm.label}`,"disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"click":function($event){$event.stopPropagation();}}}),_c('label',{class:[
      `form-radio__label`,
      _vm.hover && `hover`,
      _vm.focus && `active focus`
    ],attrs:{"for":`singleRadio-${_vm.label}`}},[_vm._v(_vm._s(_vm.label)+" "),(_vm.required)?_c('span',{staticClass:"required"}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }